// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderAlph_container__2Ay5H","button":"OrderAlph_button__2eiio"};